module.exports = __webpack_public_path__ + "static/media/banner_binary-half.497194c1.png";